import { motion } from "framer-motion"
import { BiGlobe, BiRocket } from "react-icons/bi"
import { TbVaccine } from "react-icons/tb"

const services = [
  {
    icon: <BiGlobe className="w-8 h-8" />,
    name: "Website",
    delay: 0,
  },
  {
    icon: (
      <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.523 15.341c-.784 1.215-1.312 2.046-2.681 2.046-1.371 0-1.832-.83-3.471-.83-1.64 0-2.146.83-2.93.83-1.37 0-1.915-.83-2.699-2.046-1.835-2.724-2.043-7.916.795-7.916 1.193 0 1.687.83 2.93.83 1.242 0 1.54-.83 2.93-.83 1.39 0 1.918.83 2.724.83 2.838 0 2.247-5.215.397-5.215-.397 0-.794.208-1.191.415-.398.208-.795.415-1.39.415-.596 0-.994-.207-1.39-.415-.397-.207-.794-.415-1.191-.415-1.85 0-2.442 5.215.396 5.215.806 0 1.334-.83 2.724-.83 1.39 0 1.688.83 2.93.83 1.243 0 1.737-.83 2.93-.83 2.838 0 2.63 5.192.795 7.916z" />
      </svg>
    ),
    name: "Android",
    delay: 0.1,
  },
  {
    icon: (
      <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z" />
      </svg>
    ),
    name: "IOS",
    delay: 0.2,
  },
  {
    icon: (
      <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
        <path d="M15 4.5C15 3.12 13.88 2 12.5 2S10 3.12 10 4.5V6H9V4.5C9 2.57 10.57 1 12.5 1S16 2.57 16 4.5V6h-1V4.5zM17 7H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 13H7V9h10v11z" />
      </svg>
    ),
    name: "Watch",
    delay: 0.3,
  },
  {
    icon: <TbVaccine className="w-8 h-8" />,
    name: "Tv",
    delay: 0.4,
  },
  {
    icon: <BiRocket className="w-8 h-8" />,
    name: "IOT",
    delay: 0.5,
  },
]

export default function ServiceSection() {
  return (
    <div className="min-h-screen bg-[#1a1b4b] flex flex-col items-center justify-center p-4 md:p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-16"
      >
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-blue-400 mb-4 tracking-wider"
        >
          OUR OFFERING
        </motion.p>
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-4xl md:text-5xl font-bold text-white max-w-3xl mx-auto leading-tight"
        >
          Enhance And Pioneer Using Technology Trends
        </motion.h1>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 max-w-7xl w-full">
        {services.map((service, index) => (
          <motion.div
            key={service.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: service.delay, duration: 0.5 }}
            className="relative group"
          >
            <div className="relative bg-[#0f1033] h-[180px] rounded-lg overflow-hidden flex flex-col items-center justify-center gap-4 transition-all duration-300">
              {/* Corner decorations - only visible on hover */}
              <div className="absolute top-0 left-0 w-20 h-20 bg-blue-600/0 -translate-x-1/2 -translate-y-1/2 transform rotate-45 group-hover:bg-blue-600/20 transition-all duration-300" />
              <div className="absolute top-0 right-0 w-20 h-20 bg-blue-600/0 translate-x-1/2 -translate-y-1/2 transform rotate-45 group-hover:bg-blue-600/20 transition-all duration-300" />
              <div className="absolute bottom-0 left-0 w-20 h-20 bg-blue-600/0 -translate-x-1/2 translate-y-1/2 transform rotate-45 group-hover:bg-blue-600/20 transition-all duration-300" />
              <div className="absolute bottom-0 right-0 w-20 h-20 bg-blue-600/0 translate-x-1/2 translate-y-1/2 transform rotate-45 group-hover:bg-blue-600/20 transition-all duration-300" />
              
              {/* Small decorative dot */}
              <div className="absolute bottom-6 right-6 w-1.5 h-1.5 rounded-full bg-blue-600/0 group-hover:bg-blue-600/50 transition-all duration-300" />
              
              {/* Icon container with rotation */}
              <motion.div
                transition={{ duration: 0.7, ease: "easeInOut" }}
                className="relative z-10 mb-2"
              >
                <div className="p-4 rounded-full bg-[#1a1b4b] group-hover:bg-blue-600 text-blue-400 group-hover:text-white shadow-lg transform transition-all duration-300">
                  {service.icon}
                </div>
              </motion.div>
              
              <h3 className="text-white text-xl font-bold relative z-10">{service.name}</h3>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

